import type { Node } from 'prosemirror-model';
import type { EditorState, Transaction } from 'prosemirror-state';

import { createVideoCommand } from './commands/create-video.command';
import { removeVideoAttributesCommand } from './commands/remove-video.command';
import { updateVideoAttributesCommand } from './commands/update-video-attributes.command';
import { DEFAULT_VIDEO_WIDTH, DEFAULT_VIDEO_HEIGHT } from './video-plugin.consts';

export class VideoPluginService {
  public static insert(src: string, state: EditorState, dispatch: (tr: Transaction) => void) {
    createVideoCommand({ src, width: DEFAULT_VIDEO_WIDTH, height: DEFAULT_VIDEO_HEIGHT })(
      state,
      dispatch,
    );
  }

  public static updateSrc(
    videoNode: Node,
    src: string,
    state: EditorState,
    dispatch: (tr: Transaction) => void,
  ) {
    updateVideoAttributesCommand(videoNode, {
      src,
      width: DEFAULT_VIDEO_WIDTH,
      height: DEFAULT_VIDEO_HEIGHT,
    })(state, dispatch);
  }

  public static delete(
    position: number,
    state: EditorState,
    dispatch: (tr: Transaction) => void,
    focus: () => void,
  ) {
    removeVideoAttributesCommand(position)(state, dispatch);
    focus();
  }

  public static resetSize(
    position: number,
    state: EditorState,
    dispatch: (tr: Transaction) => void,
  ) {
    const videoNode = state.doc.nodeAt(position);

    if (!videoNode?.attrs.src) return;

    VideoPluginService.updateWidth(
      position,
      DEFAULT_VIDEO_WIDTH,
      DEFAULT_VIDEO_HEIGHT,
      state,
      dispatch,
    );
  }

  public static updateWidth(
    position: number,
    width: number,
    height: number,
    state: EditorState,
    dispatch: (tr: Transaction) => void,
  ) {
    const tr = state.tr
      .setNodeAttribute(position, 'width', width)
      .setNodeAttribute(position, 'height', height);

    dispatch(tr);
  }
}
